import React from 'react';

import {formatNumber} from '../lib/helpers';

function Number({children}) {
  const fullNumber = children === null || children === undefined || isNaN(children) ? "(no value)" : children.toLocaleString();
  return <span title={fullNumber}>{formatNumber(children)}</span>;
}

export default Number;